import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';

export type EditRoutingFilterButtonProps = Readonly<{
  onClick: () => void;
  disabled?: boolean;
}>;

export function EditRoutingFilterButton(props: EditRoutingFilterButtonProps) {
  return (
    <ButtonWidget
      testId="edit-routing-filter-button"
      buttonType={ButtonType.Icon}
      onClick={props.onClick}
      title={Messages.edit()}
      aria-label={Messages.edit()}
      disabled={props.disabled}
    >
      <img src={imgPath('pencil_14px_small.svg')} alt={Messages.edit()} aria-hidden={true} />
    </ButtonWidget>
  );
}
